export default __webpack_public_path__ + "static/ProValue_2@768-613a501dfddc47241e078e1a62847b17.webp";